import React from 'react';
import PropTypes from 'prop-types';

import '../styles/OffMenu.css';
import MenuHeader from './MenuHeader';
import {ReactComponent as BackIcon} from '../icons/back-icon.svg';
import {ReactComponent as CancelIcon} from '../icons/cancel-icon.svg';

const icons = {
    back: <BackIcon className="Icon-topbar" />,
    cancel: <CancelIcon className="Icon-topbar" />,
}

const OffMenu = ({ name, title}) => (
    <>
      <MenuHeader itemName={name} />
      <div className="Off-container">
        <div>{title}</div>
        <div className="Off-button Button-active">Off</div>
        <div className="Off-cancel-button">{icons.cancel}{icons.back}</div>
      </div>
    </>
  );
  
OffMenu.propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
}

export default OffMenu;